import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaTimes } from 'react-icons/fa';
import './AdBanner.css';

const AdBanner = ({ images = [], aspectRatio = '1 / 1' }) => {
  const [ref, inView] = useInView({ threshold: 0.15, triggerOnce: true });
  const [activeImage, setActiveImage] = useState(null);

  return (
    <>
      <div className="ad-banner" ref={ref}>
        {images.map((src, i) => (
          <motion.div
            key={src}
            className="ad-banner__img-wrap"
            style={{ aspectRatio }}
            initial={{ opacity: 0, y: 36 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.55, ease: 'easeOut', delay: i * 0.08 }}
            onClick={() => setActiveImage(src)}
          >
            <img src={src} alt="KAT99 Promotion" loading="lazy" />
          </motion.div>
        ))}
      </div>

      <AnimatePresence>
        {activeImage && (
          <motion.div
            className="ad-banner__lightbox"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setActiveImage(null)}
          >
            <button className="ad-banner__lightbox-close" onClick={() => setActiveImage(null)} aria-label="Close">
              <FaTimes />
            </button>
            <motion.img
              src={activeImage}
              alt="KAT99 Promotion"
              initial={{ scale: 0.94, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.94, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default AdBanner;
